import { createStore } from "redux";
import rootReducer from "./reducers";

export const STORE = createStore(rootReducer);